import { FEATURE_NAMES } from '../constants';

export const FEATURE_NAME = FEATURE_NAMES.sessionTrace;
